import { useEffect, useState } from "react";

import {
  ADMIN_EMBEDDED_PREVIEW_ROOT_CLASS,
  isAdminEmbeddedPreview,
} from "@/lib/adminLivePreview";

/**
 * Activa estilos/documento para previews admin en iframe: altura 100% del
 * contenedor (no 100dvh del browser) y sin body position:fixed.
 */
export function useAdminEmbeddedPreviewDocument(): boolean {
  const [embedded] = useState(() => isAdminEmbeddedPreview());

  useEffect(() => {
    if (!embedded) return;
    const root = document.documentElement;
    root.classList.add(ADMIN_EMBEDDED_PREVIEW_ROOT_CLASS);
    const saved = {
      overflow: document.body.style.overflow,
      height: document.body.style.height,
      margin: document.body.style.margin,
      position: document.body.style.position,
      width: document.body.style.width,
    };
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
    document.body.style.margin = "0";
    document.body.style.position = "relative";
    document.body.style.width = "100%";
    return () => {
      root.classList.remove(ADMIN_EMBEDDED_PREVIEW_ROOT_CLASS);
      document.body.style.overflow = saved.overflow;
      document.body.style.height = saved.height;
      document.body.style.margin = saved.margin;
      document.body.style.position = saved.position;
      document.body.style.width = saved.width;
    };
  }, [embedded]);

  return embedded;
}